<!-- ProjectForm.vue -->
<template>
  <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
    <form @submit.prevent="submit">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
        <text-input v-model="form.cleanup_hours" :error="form.errors.cleanup_hours" class="pb-8 pr-6 w-full lg:w-1/2" label="Cleanup hours" />

        <select-input v-model="form.organization_id" :disabled="!isAdmin" :error="form.errors.organization_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Organization">
          <option v-for="org in organizations" :key="org.id" :value="org.id">{{ org.name }}</option>
          <option :value="null">Select an organization</option>
        </select-input>
      </div>
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
        <slot name="actions"></slot>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'

export default {
  components: { TextInput, SelectInput },
  props: {
    form: Object,
    organizations: Array,
    isTechnician: {
      type: Boolean,
      default: false,
    },
    showOrganizationField: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    submit: {
      type: Function,
      required: true,
    }
  }
}
</script>
